function Error () {
  window.location.href = '/';
}

export default Error;